import { DatePicker } from '@mantine/dates';
import { useState } from 'react';

interface Props {
  value?: Date;
  onChange: (value: Date) => void;
  minDate?: Date;
  maxDate?: Date;
}

export const Calendar = ({ value, onChange, minDate, maxDate }: Props) => {
  const [date, setDate] = useState<Date | undefined>(value);

  return (
    <DatePicker
      // Opens on the month of the given value, not on today's: the Extend Probation dialog starts months ahead.
      defaultDate={value}
      maxDate={maxDate}
      minDate={minDate}
      value={date}
      onChange={date => {
        if (date) {
          setDate(date);
          onChange(date);
        }
      }}
    />
  );
};
